<h2 mat-dialog-title>{{ "setReminderDialogTitle" | translate }}</h2>

<mat-dialog-content>
  <p class="set-reminder-dialog__supporting-text">{{ "setReminderDialogSupportingText" | translate }}</p>
  @if (formattedNextReminderAt; as reminderDate) {
  <p class="set-reminder-dialog__next-date" data-testid="set-reminder-next-date">
    {{ "nextReminderDate" | translate : { date: reminderDate } }}
  </p>
  }

  <mat-form-field appearance="outline" class="set-reminder-dialog__interval-field">
    <mat-label>{{ "remindMeEvery" | translate }}</mat-label>
    <mat-select [formControl]="interval" data-testid="set-reminder-interval-select">
      @for (option of intervals; track option.value) {
      <mat-option [value]="option.value" [attr.data-testid]="'set-reminder-option-' + option.value">
        {{ option.label | translate }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="set-reminder-dialog__primary-actions">
    <div class="set-reminder-dialog__cancel-action">
      <wil-cta-button
        [disabled]="isSubmitting()"
        [loading]="false"
        [ctaText]="'cancel' | translate"
        [style]="'secondary'"
        [size]="'small'"
        (ctaClick)="cancel()"
        data-testid="set-reminder-cancel-button"
      ></wil-cta-button>
    </div>
    <div class="set-reminder-dialog__reminder-actions">
      @if (data.reminder) {
      <wil-cta-button
        [disabled]="isSubmitting()"
        [loading]="isSubmitting()"
        [ctaText]="'turnOffReminder' | translate"
        [style]="'warn'"
        [size]="'small'"
        (ctaClick)="disable()"
        data-testid="set-reminder-disable-button"
      ></wil-cta-button>
      }
      <wil-cta-button
        [disabled]="interval.invalid || isSubmitting()"
        [loading]="isSubmitting()"
        [ctaText]="(data.reminder ? 'updateReminder' : 'setReminder') | translate"
        [style]="'primary'"
        [size]="'small'"
        (ctaClick)="submit()"
        data-testid="set-reminder-submit-button"
      ></wil-cta-button>
    </div>
  </div>
</mat-dialog-actions>
